import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Roboto:400,700');
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
  }
  html {
    font-size: 16px;
    font-family: 'Roboto', sans-serif;
  }
  * {
    box-sizing: border-box;
  }
  #root {
    height: 100%;
    width: 100%;
  }
`;
